export var transaction = {
  methods: {
    apiCatalog(dictionary) {
      return this.comboField(dictionary) === true && dictionary.catalogType === "api";
    },
    selfCatalog(dictionary) {
      return this.comboField(dictionary) === true && dictionary.catalogType === "catalog";
    },
    apiCatalogOtherFields(formFieldEx) {
      const dictionary = this.findDictionary(formFieldEx.formField.dictionaryName);
      return this.apiCatalog(dictionary) && this.notBlank(formFieldEx.api.otherFieldsId);
    },
    formScreen(screen) {
      return screen.transaction.type === "form";
    },
    crudScreen(screen) {
      return screen.transaction.category == 'crud';
    },
    queryScreen(screen) {
      return screen.transaction.type === "query";
    },
    querySimpleScreen(screen) {
      return this.queryScreen(screen) && !this.queryDashboardScreen(screen);
    },
    canvasScreen(screen) {
      return screen.transaction.type === "canvas";
    },
    backTransaction(screen) {
      return screen.transaction.type === "back";
    },
    calendarScreen(screen) {
      return screen.transaction.type === "calendar";
    },
    queryFileUploadScreen(screen) {
      return this.queryScreen(screen) &&
        (screen.transaction.fileQuery == 'upload' || screen.transaction.fileQuery == 'both');
    },
    queryFileDownloadScreen(screen) {
      return this.queryScreen(screen) &&
        (screen.transaction.fileQuery == 'download' || screen.transaction.fileQuery == 'both');
    },
    queryDashboardScreen(screen) {
      return this.queryScreen(screen) && screen.transaction.dashboard;
    },
    formFilterScreen(input /*{screen, interactive, dynamic}*/) {
      const queryScreen = this.queryScreen(input.screen);
      const calendarScreen = this.calendarScreen(input.screen);
      let filter = input.dynamic;
      input.screen.formFieldsEx.forEach((formFieldEx) => {
        if (input.interactive) {
          if (this.interactiveField(formFieldEx.formField.access)) {
            filter = true;
          }
        } else {
          if (this.visibleField(formFieldEx.formField.access)) {
            filter = true;
          }
        }
      });
      const result = (queryScreen || calendarScreen) && filter;
      return result;
    },

    formAllReadOnly(screen) {
      const interactive = screen.formFieldsEx.find(ffe => {
        return this.interactiveField(ffe.formField.access);
      });
      return interactive;
    },

    formFirstFilterScreen(screen) {
      const queryScreen = this.queryScreen(screen);
      const calendarScreen = this.calendarScreen(screen);
      let filter = false;
      screen.formFieldsEx.forEach((formFieldEx) => {
        if (this.requiredField(formFieldEx.formField.access) && this.emptyString(formFieldEx.formField.defaultValue)) {
          filter = true;
        }
      });
      return (queryScreen || calendarScreen) && filter;
    },

    formFilterOptionalScreen(screen) {
      const queryScreen = this.queryScreen(screen);
      const calendarScreen = this.calendarScreen(screen);
      let optional = false;
      screen.formFieldsEx.forEach((formFieldEx) => {
        if (this.optionalField(formFieldEx.formField.access)) {
          optional = true;
        }
      });
      return (queryScreen || calendarScreen) && optional;
    },

    formUploadScreen(screen) {
      const formScreen = this.formScreen(screen);
      let result = false;
      screen.formFieldsEx.forEach(formFieldEx => {
        const dictionary = this.findDictionary(screen, formFieldEx.formField.dictionaryName);
        if (this.fileInputField(dictionary)) {
          result = true;
        }
      })
      return formScreen && result;
    },

    formJumpScreen(screen) {
      return this.notBlank(screen.transaction.destTranName);
    },

    pageableQuery(screen) {
      return this.greatherThanZero(screen.transaction.pageLimit);
    },

    richQuery(screen) {
      return this.pageableQuery(screen) || screen.transaction.richQuery;
    },

    transactionTypeTitle(type) {
      switch (type) {
        case 'query': return this.translatedText('queryTypeTitle');
        case 'form': return this.translatedText('formTypeTitle');
        case 'canvas': return this.translatedText('canvasTypeTitle');
      }
    },
    bulkEnabled(screen) {
      const result = screen && this.queryScreen(screen) && this.notBlank(screen.transaction.bulkMode);
      return result;
    },
    bulkCheck(screen) {
      return this.bulkEnabled(screen) && screen.transaction.bulkMode == "check";
    },
    bulkContent(screen) {
      return this.bulkEnabled(screen) && screen.transaction.bulkMode == "content";
    },

    basicBuildInputData(inputFields, data) {
      let inputData = {};
      let sourceData = data;
      if (this.notBlank(inputFields)) {
        inputFields.split(",").forEach((inputField) => {
          let source = inputField;
          let target = inputField;
          if (inputField.includes('=')) {
            source = inputField.split('=')[0];
            target = inputField.split('=')[0];
            sourceData[source] = inputField.split('=')[1];
          }
          if (source.includes(":")) {
            source = source.split(":")[0];
            target = source.split(":")[1];
          }
          
          inputData[target] = sourceData[source];
        });
      }
      return inputData;
    },

    buildInputData(inputFields) {
      let inputData = {};
      if (this.notBlank(inputFields)) {
        inputFields.split(",").forEach((inputField) => {
          let source = inputField;
          let target = inputField;
          if (inputField.includes('=')) {
            source = inputField.split('=')[0];
            target = inputField.split('=')[0];
            inputData[source] = inputField.split('=')[1];
          }
          if (inputField.includes(":")) {
            source = inputField.split(":")[0];
            target = inputField.split(":")[1];
          }
          inputData[target] = this.getFieldValueByName(
            source,
            this.screen.formFieldsEx,
            this.formData
          );
        });
      }
      return inputData;
    },

    queryConceptScreen(screen) {
      return this.queryScreen(screen) || this.calendarScreen(screen) || this.canvasScreen(screen);
    },

    externalScreen(screen) {
      return screen.transaction.external;
    },

    externalScreenBehavior(screen, applicationName) {
      return this.externalScreen(screen) && applicationName == null;
    },

    contextBucket(screen) {
      return screen.bucket;
    },

    contextTheme(screen) {
      return screen.theme;
    }
  },

}